module.exports = __webpack_public_path__ + "static/media/rsz_motorbike.5f5a0079.png";